var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "main",
    { staticClass: "pkg" },
    [
      _vm._m(0),
      _vm._v(" "),
      _c("section", { staticClass: "content" }, [
        _c(
          "section",
          { staticClass: "cards", attrs: { "aria-label": "套餐列表" } },
          _vm._l(_vm.packages0, function(item) {
            return _c(
              "article",
              {
                key: item.id,
                staticClass: "card",
                class: { "card--hot": _vm.packageID === item.id },
                attrs: { "aria-label": "套餐卡片" },
                on: {
                  click: function($event) {
                    return _vm.checkPackage(item)
                  }
                }
              },
              [
                _c("h2", { staticClass: "card-title" }, [
                  _vm._v(_vm._s(item.title))
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "card-price" }, [
                  _c("span", { staticClass: "price-symbol" }, [_vm._v("¥")]),
                  _c("span", { staticClass: "price-num" }, [
                    _vm._v(_vm._s(item.price))
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card-meta" }, [
                  _c("p", { staticClass: "card-desc" }, [
                    _vm._v(_vm._s(item.typeName))
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "card-btn",
                    attrs: { type: "button" },
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        _vm.checkPackage(item)
                        _vm.createOrder()
                      }
                    }
                  },
                  [_vm._v("立即订购")]
                )
              ]
            )
          }),
          0
        ),
        _vm._v(" "),
        _vm.tipsText
          ? _c(
              "section",
              { staticClass: "notice", attrs: { "aria-label": "购买须知" } },
              [
                _c("h3", { staticClass: "notice-title" }, [_vm._v("购买须知")]),
                _vm._v(" "),
                _c("p", { staticClass: "notice-body" }, [
                  _vm._v(_vm._s(_vm.tipsText))
                ])
              ]
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("footer", { staticClass: "sticky" }, [
        _c("label", { staticClass: "agree" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.agreed,
                expression: "agreed"
              }
            ],
            staticClass: "agree-check",
            attrs: { type: "checkbox" },
            domProps: {
              checked: Array.isArray(_vm.agreed)
                ? _vm._i(_vm.agreed, null) > -1
                : _vm.agreed
            },
            on: {
              change: function($event) {
                var $$a = _vm.agreed,
                  $$el = $event.target,
                  $$c = $$el.checked ? true : false
                if (Array.isArray($$a)) {
                  var $$v = null,
                    $$i = _vm._i($$a, $$v)
                  if ($$el.checked) {
                    $$i < 0 && (_vm.agreed = $$a.concat([$$v]))
                  } else {
                    $$i > -1 &&
                      (_vm.agreed = $$a
                        .slice(0, $$i)
                        .concat($$a.slice($$i + 1)))
                  }
                } else {
                  _vm.agreed = $$c
                }
              }
            }
          }),
          _vm._v(" "),
          _c("span", { staticClass: "agreement-text" }, [
            _vm._v("已阅读并同意"),
            _c(
              "a",
              {
                staticClass: "agreement-link",
                attrs: { href: "javascript:;" },
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                    $event.preventDefault()
                    return _vm.openAgreement($event)
                  }
                }
              },
              [_vm._v("《用户服务协议》")]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "van-popup",
        {
          staticClass: "agreement-popup",
          attrs: { position: "bottom", round: "" },
          model: {
            value: _vm.showAgreement,
            callback: function($$v) {
              _vm.showAgreement = $$v
            },
            expression: "showAgreement"
          }
        },
        [
          _c("div", { staticClass: "agreement-panel" }, [
            _c("div", { staticClass: "agreement-header" }, [
              _c("span", [_vm._v("用户服务协议")]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "agreement-close",
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      _vm.showAgreement = false
                    }
                  }
                },
                [_vm._v("关闭")]
              )
            ]),
            _vm._v(" "),
            _vm.agreementLoading
              ? _c(
                  "div",
                  { staticClass: "agreement-body" },
                  [
                    _c("van-loading", {
                      attrs: { size: "22px", color: "#1989fa" }
                    }),
                    _vm._v(" "),
                    _c("p", [_vm._v("协议加载中...")])
                  ],
                  1
                )
              : _c(
                  "div",
                  { staticClass: "agreement-body agreement-content" },
                  _vm._l(_vm.agreementLines, function(line, idx) {
                    return _c("p", { key: idx }, [_vm._v(_vm._s(line))])
                  }),
                  0
                )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "header",
      { staticClass: "hero", staticStyle: { height: "1.36rem" } },
      [
        _c(
          "div",
          {
            staticStyle: {
              width: "3.75rem",
              margin: "0 auto",
              position: "relative",
              height: "1.36rem"
            }
          },
          [
            _c("div", {
              staticClass: "hero-bg",
              attrs: { "aria-hidden": "true" }
            }),
            _vm._v(" "),
            _c("img", {
              staticClass: "hero-top-title",
              attrs: {
                src: require("./static/images/package/liuliangtaocan.png"),
                alt: "流量套餐"
              }
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "hero-card-title",
                attrs: { "aria-hidden": "true" }
              },
              [_vm._v("基础套餐")]
            )
          ]
        )
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4b7f9640", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7f9640","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/newpage/recharge.vue
// module id = null
// module chunks = 